var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    stroke: "#202117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6992 31.1996C26.4512 32.4992 25.3093 33.4813 23.9372 33.4813H12.6868L7.06203 38V33.4813C6.28527 33.4813 5.58245 33.1661 5.07382 32.6575C4.56444 32.1489 4.25 31.4453 4.25 30.6685V28.398C4.91174 28.7812 5.68029 29 6.49963 29H24.4996L26.6992 31.1996Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 6.5V24.5C38 25.7428 37.4966 26.8676 36.6825 27.6825C35.8676 28.4966 34.7428 29 33.5 29V38L24.5 29H6.5C5.68066 29 4.91212 28.7812 4.25037 28.398C2.90523 27.6205 2 26.1663 2 24.5V6.5C2 4.01436 4.01436 2 6.5 2H33.5C35.9856 2 38 4.01436 38 6.5Z",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.625 12.125V11C16.625 9.13609 18.136 7.62506 20 7.62506C21.8639 7.62506 23.3749 9.13609 23.3749 11C23.3749 11.8951 23.0193 12.7536 22.3864 13.3865L21.0313 14.7416C20.3984 15.3745 20.0428 16.233 20.0428 17.1281V18.8749",
    stroke: "black",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 24.4954C20.5862 24.4954 21.1476 23.9801 21.1205 23.3751C21.0933 22.7681 20.6282 22.2548 20.0002 22.2548C19.4142 22.2548 18.8527 22.77 18.8798 23.3751C18.907 23.9821 19.3721 24.4954 20.0002 24.4954Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalFaq);
export default __webpack_public_path__ + "static/media/modal-faq.5b0de65e6786068273035e39edc57932.svg";
export { ForwardRef as ReactComponent };